export default __webpack_public_path__ + "static/media/mappin_gray.983bd6c5.svg";